import { Space, Card } from 'antd';
import { query } from 'helpers/QueryHelper';
import withAuthenticator from 'HOCs/withAuthenticator';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import styles from './create-class.module.css';
// import data from './data';

const fetcher = (teacherId: any) => () => {
  return query('p_SACHSO_CLASSES_GetClasses_ByTeacherId', { teacherId });
};
function ListClasses({ onMoveToSubjects, loggedInUser }) {
  const key = ['p_SACHSO_CLASSES_GetClasses_ByTeacherId', loggedInUser?.id];
  const { data, isLoading } = useQuery(key, fetcher(loggedInUser?.id));
  if (isLoading) return '';
  // return ''
  return (
    <Space size={[0, 32]} wrap style={{ display: 'flex', justifyContent: 'space-between' }}>
      {data.map((item) => {
        const grade = item.className.split(' ');
        return (
          <Card
            key={item.id}
            style={{
              border: '2px solid',
              backgroundColor: '#11CDEF',
              borderRadius: 8,
              color: 'white',
            }}
            className={styles.cardHover}
            onClick={() => onMoveToSubjects(item)}
          >
            <div
              style={{
                width: 252,
                height: 152,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: 32,
              }}
            >
              <span>{grade[0]}</span>
              <span
                style={{
                  fontSize: 72,
                  transform: 'skewX(-10deg)',
                  marginLeft: 20,
                }}
              >
                {grade[1]}
              </span>
            </div>
          </Card>
        );
      })}
    </Space>
  );
}

ListClasses.propTypes = {
  onMoveToSubjects: PropTypes.func.isRequired,
};

export default withAuthenticator(ListClasses);
